module.exports = "https://cdn-assessment.mathletics.com/app/102/assets/fonts/e004c490a841cb5a964dc1869e09a3a6.ttf";